import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { reduce, some } from "lodash"
import { Expression } from "./expressions"

export const SortDirectionEnum = {
    Asc: "Asc",
    Desc: "Desc",
    Not: "Not",
}

export type SortDirection = keyof typeof SortDirectionEnum

export type Sort = {
    direction: SortDirection
    by: Maybe<string>
}

export type QueryApiParameters = {
    filter?: Maybe<Expression>
    sort?: Sort[]
    limit?: number
    offset?: number
}

export const printQueryApiSort = (sorts: Maybe<Sort[]>) =>
    reduce(
        sorts,
        (acc, sort) =>
            acc +
            (acc === "" ? "" : ",") +
            (sort.direction === SortDirectionEnum.Not || !sort.direction || !sort.by
                ? ""
                : `${sort.by}.${sort.direction.toLowerCase()}`),
        ""
    ) || null

export const isAnyhowSorted = (sorts: Maybe<Sort[]>): boolean =>
    some(sorts, sort => sort.direction !== SortDirectionEnum.Not)

export const prepareQueryApiParameters = (parameters: QueryApiParameters): Record<string, any> => ({
    ...(parameters.filter != null
        ? {
              filter: parameters.filter.print(),
          }
        : {}),
    ...(isAnyhowSorted(parameters.sort)
        ? {
              sort: printQueryApiSort(parameters.sort),
          }
        : {}),
    ...(parameters.limit != null
        ? {
              count: parameters.limit,
          }
        : {}),
    ...(parameters.offset != null
        ? {
              offset: parameters.offset,
          }
        : {}),
})
